/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiGroomingSearchRetrieveParams } from './model/apiGroomingSearchRetrieveParams';
import type { GroomingSearchResponse } from './model/groomingSearchResponse';

export const apiGroomingSearchRetrieve = (
  params?: ApiGroomingSearchRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<GroomingSearchResponse>({
    url: `/api/v7/grooming/search-results/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiGroomingSearchRetrieveQueryKey = (params?: ApiGroomingSearchRetrieveParams) => {
  return [`/api/v7/grooming/search-results/`, ...(params ? [params] : [])] as const;
};

export const getApiGroomingSearchRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiGroomingSearchRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiGroomingSearchRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiGroomingSearchRetrieve>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiGroomingSearchRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGroomingSearchRetrieve>>> = ({
    signal,
  }) => apiGroomingSearchRetrieve(params, signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiGroomingSearchRetrieve>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiGroomingSearchRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiGroomingSearchRetrieve>>
>;
export type ApiGroomingSearchRetrieveQueryError = ErrorType<unknown>;

export function useApiGroomingSearchRetrieve<
  TData = Awaited<ReturnType<typeof apiGroomingSearchRetrieve>>,
  TError = ErrorType<unknown>
>(
  params?: ApiGroomingSearchRetrieveParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiGroomingSearchRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiGroomingSearchRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
